import { render, staticRenderFns } from "./forgotPwd.vue?vue&type=template&id=1eb583ca&scoped=true&"
import script from "./forgotPwd.vue?vue&type=script&lang=ts&"
export * from "./forgotPwd.vue?vue&type=script&lang=ts&"
import style0 from "./forgotPwd.vue?vue&type=style&index=0&id=1eb583ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb583ca",
  null
  
)

export default component.exports